import { normalizeVoiceText, parseVoiceDateKey } from "../../voice/ownerVoiceParsers";
import { chooseEntity, spokenDate } from "../ownerJarvisUtils";

function navigationQuery(value = "") {
  return normalizeVoiceText(value)
    .replace(/\b(?:jarvis|abri|abrime|abrir|mostra|mostrame|mostrar|ver|anda|andame|llevame|lleva|ir|quiero|la|el|una|un|ficha|detalle|de|del|al|a|cliente|clientes|persona|personas|proyecto|proyectos|frente|iniciativa|rutina|rutinas|habito|habitos|dia|fecha)\b/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function createOwnerJarvisEntityNavigationCapability({ ownerApi, navigate }) {
  return {
    id: "entity-navigation",
    domain: "navigation",
    async handle({ raw, text }) {
      const navigationRequest = /\b(?:abri|abrime|abrir|mostra|mostrame|mostrar|llevame|anda|ir a|ver la ficha|ver ficha)\b/.test(text);
      if (!navigationRequest) return null;

      const wantsClient = /\b(cliente|persona)\b/.test(text);
      const wantsProject = /\b(proyecto|frente|iniciativa)\b/.test(text);
      const wantsRoutine = /\b(rutina|habito)\b/.test(text);
      const dateKey = !wantsClient && !wantsProject && !wantsRoutine ? parseVoiceDateKey(raw) : null;
      if (dateKey && /\b(?:dia|fecha|hoy|ayer|lunes|martes|miercoles|jueves|viernes|sabado|domingo|enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|\d{1,2})\b/.test(text)) {
        navigate(`/dashboard/owner/calendario?fecha=${encodeURIComponent(dateKey)}`);
        return { handled: true, message: `Abro el ${spokenDate(dateKey)}.` };
      }

      const query = navigationQuery(text);
      const [clientsResponse, initiativesResponse, routinesResponse] = await Promise.all([
        ownerApi.listClients({ query, limit: 60 }),
        ownerApi.listInitiatives({ status: "", limit: 100 }),
        ownerApi.listRoutines({ includeInactive: true, limit: 150 }),
      ]);
      let candidates = [
        ...(clientsResponse?.clients || []).map((row) => ({ ...row, __kind: "client" })),
        ...(initiativesResponse?.initiatives || []).map((row) => ({ ...row, __kind: "project" })),
        ...(routinesResponse?.routines || []).map((row) => ({ ...row, __kind: "routine" })),
      ];
      if (wantsClient) candidates = candidates.filter((row) => row.__kind === "client");
      if (wantsProject) candidates = candidates.filter((row) => row.__kind === "project");
      if (wantsRoutine) candidates = candidates.filter((row) => row.__kind === "routine");
      const result = chooseEntity(candidates, query, ["name", "company", "email", "outcome", "notes"]);
      if (result.row) {
        const row = result.row;
        const id = String(row?.id || row?._id || "");
        if (row.__kind === "client") navigate(`/dashboard/owner/clientes?cliente=${encodeURIComponent(id)}`);
        if (row.__kind === "project") navigate(`/dashboard/owner/proyectos/${encodeURIComponent(id)}`);
        if (row.__kind === "routine") navigate(`/dashboard/owner/rutinas/${encodeURIComponent(id)}`);
        return { handled: true, message: `Abro ${row.name || row.company || "la ficha"}.` };
      }
      if (result.alternatives?.length) {
        return { handled: true, message: `Encontré varias fichas parecidas: ${result.alternatives.map((row) => row.name || row.company).join(", ")}. Decime cuál.` };
      }
      return { handled: true, message: "No encontré esa ficha. Decime el nombre un poco más completo." };
    },
  };
}
